﻿import React from 'react'
import { Text, Heading } from '../components/ui'
import { PermissionGuard } from '../components/PermissionGuard'

const AtendimentoAnalise: React.FC = () => (
  <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
    <PermissionGuard
        moduleName="atendimento_analise"
        permissionType="show"
        fallback={
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                Acesso Negado
              </Text>
              <Text size="sm" color="muted">
                Você não tem permissão para acessar esta página.
              </Text>
            </div>
          </div>
        }
      >
        <div className="h-full flex flex-col">
          <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
              Análise de Atendimento
            </Heading>
            <Text size="sm" color="muted" className="mt-2">
              As análises por canal estão nas páginas Whatsapp e Zendesk.
            </Text>
          </div>
        </div>
    </PermissionGuard>
  </div>
)

export default AtendimentoAnalise
